import { render, staticRenderFns } from "./contactBuyDialog.vue?vue&type=template&id=315ded3c&scoped=true"
import script from "./contactBuyDialog.vue?vue&type=script&lang=js"
export * from "./contactBuyDialog.vue?vue&type=script&lang=js"
import style0 from "./contactBuyDialog.vue?vue&type=style&index=0&id=315ded3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315ded3c",
  null
  
)

export default component.exports